// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2.22632 2H22.2263V11H2.22632V2ZM8.22827 6.5H6.22437V8.50391H8.22827V6.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M2.22632 13H18.9763C16.0768 13 13.7263 15.3505 13.7263 18.25C13.7263 19.719 14.3297 21.0471 15.3021 22H2.22632V13ZM8.22827 15.5H6.22437V17.5039H8.22827V15.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M18.9763 14.5C16.9053 14.5 15.2263 16.1789 15.2263 18.25C15.2263 20.3211 16.9053 22 18.9763 22C19.6487 22 20.2797 21.8231 20.8253 21.5132L22.4763 23.1642L23.8905 21.75L22.2395 20.099C22.5494 19.5533 22.7263 18.9223 22.7263 18.25C22.7263 16.1789 21.0474 14.5 18.9763 14.5ZM17.2263 18.25C17.2263 17.2835 18.0098 16.5 18.9763 16.5C19.9428 16.5 20.7263 17.2835 20.7263 18.25C20.7263 19.2165 19.9428 20 18.9763 20C18.0098 20 17.2263 19.2165 17.2263 18.25Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-data-search-filled')
export default class DataSearchFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'data-search-filled',
    }
  }
}
